/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NewCompanyModal.vue?vue&type=template&id=c13f0cdc&scoped=true"
import script from "./NewCompanyModal.vue?vue&type=script&lang=js"
export * from "./NewCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./NewCompanyModal.vue?vue&type=style&index=0&id=c13f0cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13f0cdc",
  null
  
)

export default component.exports